const state = {
  title: '',
  imagen: '../../../static/img/header/index.png',
  titulos: new Map([
    ['index', "El observatorio INNOTEC es un espacio virtual que tiene como objetivo monitorear la investigación y producción científica de la \
               UAPA a partir de la búsqueda, análisis, procesamiento de información, teniendo en cuenta un conjunto de métricas e informaciones de interés para la universidad.<br>\
               Su concepción responde al cumplimiento de las líneas de actuación que están explícitas en el eje de Investigación, Innovación y Formación profesional del Plan \
                estratégico de Desarrollo 2016-2020 de la Universidad Abierta para Adultos,UAPA. <br> \
               El desarrollo del proyecto mantendrá alertas a los directivos y profesores vinculados a los procesos investigativos y docente de \
               cuál es el comportamiento de la producción científica de los docentes de la universidad, cuáles son las principales líneas \
               de I+D+i que son de interés para la UAPA. <br>\
              Permitirá accionar en nuevos temas de investigación que desde las tesis de maestrías se den respuesta, así como la elaboración \
              de proyectos de investigación con la finalidad de presentarlos para conseguir financiamiento. "],
    ['nosotros', 'La Vicerrectoría de Investigación y Postgrado fue creado en el año ' +
    '2013. Está sustentada en la filosofía de la UAPA que otorga gran importancia a la ' +
    'adecuada selección del cuerpo docente, a su capacitación, a la investigación, ' +
    'como mecanismo para garantizar la calidad de su labor docente y a la innovación ' +
    'como eje fundamental en un modelo de educación a distancia.'],
    ['herramientas', 'En esta sección se socializan plataformas que pueden ser útiles para la creación de\n' +
    'perfiles para investigadores, programas gratuitos para detectar el plagio y plataformas ' +
    'para evaluar revistas que le permitan a los investigadores medir la visibilidad de la ' +
    'publicación donde desea publicar sus artículos.'],
    [3, 'three'],
    [3, 'three'],
  ]),
  imagenes: new Map([
    ['index', "../../../static/img/header/index.png"],
    ['bp', "../../../static/img/header/bp.png"],
    ['herramientas', "../../../static/img/header/herramientas.png"],
    ['directorio', "../../../static/img/header/directorio.png"],
    ['enlaces', "../../../static/img/header/enlaces.png"],
    ['proyectos', "../../../static/img/header/proyectos.png"],
  ]),
  page_name: new Map([
    ['index', ""],
    ['nosotros', "Sobre Nosotros"],
    ['herramientas', "Herramientas para Investigadores"],
    ['banco_problemas', "Banco de Problemas"],
    ['publicaciones', "Producción Científica"],
    ['proyectos', "Proyectosa"],
    ['directorio', "Directorio de Revistas"],
    ['enlacesinteres', "Enlaces de Interés"],
  ]),
  eventos: ['Proceedings of the European Distance and E-Learning Network 2013 Annual Conference', 'DOCUMENTOS 23: Sobre el papel de los estudiantes' +
  ' en los Estudios Generales', 'Congreso Internacional de la Educación Superior (Cuba)', 'Congreso Internacional sobre Tecnología de la Información, ' +
  'Comunicación y Educación a Distancia (CITICED)', 'Pre-congreso ISFODOSU-IDEICE', '7mo Congreso Internacional IDEICE 2016', 'Congreso Internacional Universidad 2016',
    'Congreso Virtual Iberoamericano de Calidad en Educación Virtual y a Distancia: Educ@', 'V Seminario Internacional de Estudios Generales, Competencias y ' +
    'Transdisciplinariedad en los Estudios Generales. INTEC'
  ]
}

const getters = {
  title: (state) => state.title,
  imagen: (state) => state.imagen,
  events_data: (state) => state.eventos
}

const actions = {}
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/header.js